import { render, staticRenderFns } from "./PersonalLoanListing.vue?vue&type=template&id=5bc7ec96"
import script from "./PersonalLoanListing.vue?vue&type=script&lang=js"
export * from "./PersonalLoanListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports